import * as React from 'react';

import {Metric} from './metric';
import type {MetricType} from './metric';

import styles from './metrics.module.css';

type Props = {
    stats: MetricType &
        {
            key: string;
        }[];
    size?: 'small' | 'normal' | 'big';
    hasBorders?: boolean;
};

export function StatsBlockHorizontal(props: Props) {
    const {size = 'big', hasBorders = true} = props;

    return (
        <div className={hasBorders ? styles.container : styles['container--no-border']}>
            {props.stats.map((stat, index) => {
                return (
                    <React.Fragment key={stat.key}>
                        {index !== 0 ? <div className={styles.divider} /> : undefined}
                        <div className={styles['stat-container']}>
                            {/* @ts-expect-error */}
                            <Metric
                                {...stat}
                                isCentered={true}
                                centerAlignHeader={true}
                                size={size}
                            />
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}
